import {message} from 'antd';
import {get_response} from "../helper/request";

export const isDeviceIPRemote = (deviceIP) =>
	deviceIP && deviceIP !== "/" && !deviceIP.includes("localhost") && !deviceIP.includes("0.0.0.0");

export const reloadDeviceConfig = (deviceId, initCallback, successCallback, failureCallback) => {
	if(initCallback) 
		initCallback();
	
	const url = "/server/devices/" + deviceId + "/settings/reload/";
	get_response(url).then(res => {
		message.success("Settings reloaded successfully.");
		
		if(successCallback)
			successCallback();
	})
	.catch(err => {
		message.error("Reloading Failed. Contact Admin");

		if(failureCallback)
			failureCallback();
	});
}

export const stopScannerServer = (deviceId, initCallback, successCallback, failureCallback) => {
	if(initCallback) 
		initCallback();

	let url = `/delayed_server/devices/` + deviceId + '/stop_scanner_server/';
	get_response(url)
		.then(response => {
			if (response.status !== 200) {
				message.error("Failed to Stop Scanner. Contact Admin!");
			}

			if(successCallback)
				successCallback();
		})
		.catch(err => {
			if(failureCallback)
				failureCallback();
			
			console.log(err);
		})

}